import classNames from "classnames";
import React from "react";
import styled, { keyframes } from "styled-components";

const loading = keyframes`
    from {
        margin-left: 50%;
        z-index: 100;
    }

    33.3333% {
        margin-left: 0%;
        width: 100%;
        z-index: 10;
    }

    to {
        margin-left: 0%;
        width: 100%;
    }
`;

const LoadBar = styled("div")`
    border-radius: 3px;
    height: 6px;
    position: relative;
    text-align: left;
`;

const Bar = styled("div")`
    content: "";
    display: inline-block;
    height: 100%;
    position: absolute;
    width: 0;

    &:nth-child(1) {
        animation: ${loading} 3s linear infinite;
        background-color: ${(props) => props.theme.palette.primary.main};
    }

    &:nth-child(2) {
        animation: ${loading} 3s linear 1s infinite;
        background-color: #f2f2f2;
    }

    &:nth-child(3) {
        animation: ${loading} 3s linear 2s infinite;
        background-color: #666;
    }
`;

interface LoadingBarProps {
    className?: string;
}

class LoadingBar extends React.Component<LoadingBarProps> {
    public render() {
        return (
            <LoadBar className={classNames("LoadingBar", this.props.className)}>
                <Bar />
                <Bar />
                <Bar />
            </LoadBar>
        );
    }
}

export default LoadingBar;
